import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            内容分类
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            六大内容品类，满足不同观看需求，精彩内容一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-50 border-primary-200/70 hover:border-primary-400',
              accent: 'bg-accent-50 border-accent-200/70 hover:border-accent-400',
              secondary: 'bg-secondary-50 border-secondary-200/70 hover:border-secondary-400',
            };
            const iconColorMap: Record<string, string> = {
              primary: 'text-primary-600',
              accent: 'text-accent-600',
              secondary: 'text-secondary-600',
            };
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group p-6 rounded-xl border transition-all duration-300 cursor-pointer ${colorMap[cat.color] || colorMap.primary}`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  cat.color === 'accent' ? 'bg-accent-100' : cat.color === 'secondary' ? 'bg-secondary-100' : 'bg-primary-100'
                }`}>
                  <i className={`${cat.icon} text-2xl ${iconColorMap[cat.color] || iconColorMap.primary}`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}